module.exports = __webpack_public_path__ + "media/assets/images/logo_header@2x-568a7984b7528c660a19d741b107b706.png";